module.exports = "<blnd-activity object=\"pvm.customer\"></blnd-activity>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/customers/log.html
// module id = 715
// module chunks = 0